@import 'abstract/colors';
@import 'abstract/variables';

livechat-load-button {
  bottom: 210px;
  z-index: 2147483645 !important;
  min-height: 73px;
  min-width: 65px;
  opacity: 1;
  overflow: hidden;
  position: fixed;
  right: 15px;

  @include breakpoint(sm) {
    bottom: 5px;
    right: 5px;
  }

  &:not(.fc-open) {
    bottom: 210px;
    @include breakpoint(sm) {
      bottom: 5px;
      right: 5px;
    }
  }

  button {
    border-radius: 34px 8px 34px 34px;
    bottom: 6px;
    box-shadow: 0 5px 4px 0 rgb(0 0 0 / 26%);
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 5px;
    color: #ffffff !important;
    border-color: transparent;
    animation: zoom-in 500ms;
    height: 60px;
    width: 60px;

    &.button-bg-color {
      background-color: $live-chat-button-bg-color !important;
    }

    &.button-bg-color-nl {
      background-color: $live-chat-button-bg-color-nl !important;
    }

    @include breakpoint(sm) {
      height: 50px;
      width: 50px;
    }

    i {
      font-size: 23px;
      display: block;
    }
  }
}

@keyframes zoom-in {
  0% {
    transform: scale(0.5, 0.5);
  }
  100% {
    transform: scale(1, 1);
  }
}

.spinner-container {
  width: 80px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;

  @include breakpoint(sm) {
    height: 100px;
  }

  /* Fix for IE */
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    margin-left: -6px;
  }
}

.lds-spinner {
  color: $white;
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  transform: scale(0.5);
}

.lds-spinner div {
  transform-origin: 40px 40px;
  animation: lds-spinner 1.2s linear infinite;
}

.lds-spinner div:after {
  content: " ";
  display: block;
  position: absolute;
  top: 3px;
  left: 37px;
  width: 6px;
  height: 18px;
  border-radius: 20%;
  background: $white;
}

@for $i from 0 through 12 {
  .lds-spinner div:nth-child(#{$i}) {
    transform: rotate(0deg + ($i * 30));
    animation-delay: -1.1s + ($i / 10);
  }
}

@keyframes lds-spinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
